import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {LocalStorageService} from 'ngx-localstorage';
import {SharedService} from '../shared/shared.service';
import {AuthService} from '../auth/auth.service';

export function ConfigInit(http: HttpClient, storage: LocalStorageService, authService: AuthService): () => Promise<any> {
  return (): Promise<any> => {
    return new Promise((resolve) => {
      authService.login();
      resolve('');
    });
  };
}
